// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"2":"blogPost","239":"blog","443":"about","631":"contact"}[chunkId] || chunkId) + "." + {"2":"5c966b80","239":"4de6744e","443":"005fbc3c","631":"00186a8e","771":"f15059df"}[chunkId] + ".js";
};